export default "__VITE_ASSET__aPMS6RTw__"